import {Injectable} from '@angular/core';

import {ActivatedRouteSnapshot, Resolve} from '@angular/router';
import {CashSessionService} from '../_services/cash-session.service';

@Injectable()
export class CashSessionSummaryResolver implements Resolve<any> {
    constructor(private cashSessionService: CashSessionService) {
    }

    resolve(route: ActivatedRouteSnapshot) {
        return this.cashSessionService.summary(route.paramMap.get('cashSessionId'));
    }
}
